import Locales from './locales';

require('./geo');

export default class Analytics {
    constructor() {
        this.initialisedConsentCategories = [];
    }

    get getPriceLang() {
        const langFromLink = window.location.pathname.split('/')[1];
        const isLinkLocale =
            Locales.existsLocaleInSite(langFromLink.toUpperCase()) || langFromLink === 'ja' || langFromLink === 'pt-br';

        if (isLinkLocale) {
            return langFromLink;
        }
    }

    initRequiredTracking() {
        this.initAndRegisterConsentCategory(WG.GdprUserCentrics.ConsentCategories.Required, () => {
            this.initGtmDataLayer();
            WG.Tracking.run();
        });
    }

    initFunctionalTracking() {
        this.initAndRegisterConsentCategory(WG.GdprUserCentrics.ConsentCategories.Functional, () => {});
    }

    initAdvertisingTracking() {
        this.initAndRegisterConsentCategory(WG.GdprUserCentrics.ConsentCategories.Advertising, () => {
            this.initPersonalisationScript();
        });
    }

    initAndRegisterConsentCategory(consentCategory, initFn) {
        if (this.initialisedConsentCategories.indexOf(consentCategory) === -1) {
            console.log('>>>', 'initAndRegisterConsentCategory', consentCategory);
            initFn();
            this.initialisedConsentCategories.push(consentCategory);
        }
    }

    initGtmDataLayer() {
        if (window.typeOfPage === 'apps') {
            const pathname = window.location.pathname;
            const fullSlug = pathname.replace(/\/$/, '');
            const dynxid2Val = fullSlug.substr(fullSlug.lastIndexOf('/') + 1);

            window.dataLayer = [
                {
                    event: 'dynx_remarketing_ready',
                    dynxid: dynxid2Val,
                    dynxid2: 'apps'
                }
            ];
        }
    }

    isUsaOrCanadaVisitor() {
        let countryCode = '';

        if ('geo' in window && 'getCountryCode' in window.geo) {
            countryCode = window.geo.getCountryCode();
        }

        return countryCode === 'US' || countryCode === 'CA';
    }

    setMarketoCookie(isMarketoTrackingDisabled = true) {
        console.log('>>>', 'setMarketoCookie', isMarketoTrackingDisabled);
        const tenYearsInSeconds = 311040000;
        const currentDomainAndSubdomains =
            '.' + (window.location.host.match(/[a-z0-9-]+\.[a-z0-9-]{2,3}$/) || [window.location.host]).pop();

        WG.utils.setCookie('mkto_opt_out', 'true', {
            path: '/',
            expires: isMarketoTrackingDisabled ? tenYearsInSeconds : -1,
            domain: currentDomainAndSubdomains
        });
    }

    initPersonalisationScript() {
        let script = document.createElement('script');
        const env = window.location.host === 'alpha.wrke.io' ? 'engage' : 'prod';

        script.type = 'text/javascript';
        script.src = `//cdn.evgnet.com/beacon/wrike/${env}/scripts/evergage.min.js`;
        let s = document.getElementsByTagName('script')[0];

        s.parentNode.insertBefore(script, s);
    }
}



// WEBPACK FOOTER //
// ./assets/js/common/modules/analytics.js